<ion-col class="wrapper">
	<ion-chip (click)="dismiss()" class="close-icon">
		<ion-icon name="close"></ion-icon>
	</ion-chip>
	<div class="header-wrapper">
		<h2 class="title">{{ 'recom_art.title' | translate }}</h2>
		<p class="description">
			{{ 'recom_art.desc' | translate }}
		</p>
	</div>
	<ion-row class="content_block">
		@for (article of articlesList; track $index) {
			<ion-col size="6">
				<app-item-view
					(addToBasketCustomizeEvent)="addToBasketModal(article)"
					(addToBasketEvent)="addToBasketModal(article)"
					(removeArticleFromBasket)="removeFromBasketModal($event)"
					[article]="article"
					[orderValue]="orderObservable | async"
				>
				</app-item-view>
			</ion-col>
		}
	</ion-row>

	<div class="footer-btn">
		<ion-button (click)="addArticlesToBasket()" class="cancel-btn">{{ 'short_info.close' | translate }}</ion-button>
	</div>
</ion-col>
